import treatmentDefaultFragment from "../fragments/treatmentDefault";

const treatment2Query = `treatment2[]->
  ${treatmentDefaultFragment}    
`;

export default treatment2Query;
